// Supporting metrics band (5 systems) on the paid report page. Verbatim
// from PaidReport.jsx (W2c). Note: the "Supporting metrics" eyebrow copy
// here is INTENTIONALLY different from the Preview page's "The 5 supporting
// metrics behind your Business Health score" — both copies are CEO-locked.
import BlackRockBand from "../BlackRockBand";

export default function ReportSupportingScores({ supportingScores }) {
  if (!supportingScores || supportingScores.length === 0) return null;
  return (
    <div className="sf-card" style={{ marginBottom: 32 }} data-testid="paid-report-supporting-scores-card">
      <div className="sf-eyebrow" style={{ marginBottom: 22 }}>Supporting metrics</div>
      {supportingScores.map((s) => (
        <BlackRockBand
          key={s.id}
          score={s.block.score}
          label={s.block.label}
          bandId={s.block.band}
          explanation={s.block.explanation}
          metricLabel={s.metricLabel}
          size="supporting"
          testId={`paid-report-${s.id}`}
        />
      ))}
    </div>
  );
}
